// Copyright 2017 Sorama B.V.

import { UnitValue } from "units/Unit";
import { VisualExport } from "./Export";
import { ImageFormat, VideoFormat } from "./Format";

export interface FrameGenerator {
    /**
     * Indicates that the last frame has been reached, calling getFrame will result in an exception
     */
    readonly finalFrame: boolean;

    /**
     * Get the frame time for the next frame
     */
    readonly frameTime: UnitValue;

    /**
     * Get the next frame
     */
    getFrame(): Promise<string>;
}

export abstract class IExportService {
    /**
     * Export a video
     * @param format Format for the video, see VideoFormat for options
     * @param generator Frame generator that provides frames for the video
     */
    public abstract video(format: VideoFormat, generator: FrameGenerator): VisualExport;

    /**
     * Export an image
     * @param format Format for the image, see ImageFormat for options
     * @param image SVG image source to export
     */
    public abstract image(format: ImageFormat, image: string): VisualExport;
}
